"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var chCountry = exports.chCountry = function chCountry(t) {
  return {
    id: 'CH',
    name: t('Switzerland'),
    flag: '🇨🇭',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{4}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 12O1 or 8000',
    phonePrefix: '41',
    phoneLength: 9,
    unavailable: true,
    pricingVersion: 14,
    timezone: 'Europe/Zurich',
    currency: 'EUR'
  };
};